import { render, staticRenderFns } from "./ManagementAddContractorInfoEducation.vue?vue&type=template&id=5b0bb9e8&scoped=true"
import script from "./ManagementAddContractorInfoEducation.vue?vue&type=script&lang=ts"
export * from "./ManagementAddContractorInfoEducation.vue?vue&type=script&lang=ts"
import style0 from "./ManagementAddContractorInfoEducation.vue?vue&type=style&index=0&id=5b0bb9e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0bb9e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0bb9e8')) {
      api.createRecord('5b0bb9e8', component.options)
    } else {
      api.reload('5b0bb9e8', component.options)
    }
    module.hot.accept("./ManagementAddContractorInfoEducation.vue?vue&type=template&id=5b0bb9e8&scoped=true", function () {
      api.rerender('5b0bb9e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagementAddContractorInfoEducation.vue"
export default component.exports